import React from 'react'

interface TotalProductsIconProps {
  color?: string
  size?: number | string
  className?: string
}

export const TotalProductsIcon: React.FC<TotalProductsIconProps> = ({
  color = 'currentColor',
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Multiple boxes stacked */}
    <rect
      x="3"
      y="8"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="5"
      y="4"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="9"
      y="12"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="11"
      y="8"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="15"
      y="4"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
  </svg>
)

export default TotalProductsIcon
